module.exports = __webpack_public_path__ + "static/media/background_overlay.44045d86.svg";